import { Vector } from '@inter-ikea-core/core';
import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { getAllConnectorsThatOffer } from 'rangeConfig/shared/utils/connectors';

// Y-axis offset from hob connector for the hood product
const hoodOffset = 650;

const addHood = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const hoodHeight =
    rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId)?.dimensions
      .height ?? 0;

  const hobConnector = getAllConnectorsThatOffer(coreApi, 'hob').at(0);
  const currentHood = coreApi.entities
    .getByProductTypes([
      ProductType.APPLIANCE_FREE_HANGING_EXTRACTOR_HOOD,
      ProductType.APPLIANCE_CABINET_EXTRACTOR_HOOD
    ])
    .at(0);

  let targetPosition: Vector | null = null;

  if (currentHood) {
    const currentHoodPosition = coreApi.entities.getWorldPosition(currentHood);
    const currentHoodProduct = rootState.products.inMarket.find(
      p => p.coreProductId === coreApi.entities.getProductRef(currentHood)
    );
    const heightDifference = (currentHoodProduct?.dimensions.height ?? 0) - hoodHeight;
    const yValue = currentHoodPosition.Y - heightDifference / 2;
    targetPosition = new Vector(currentHoodPosition.X, yValue, currentHoodPosition.Z);
  } else if (hobConnector) {
    const hobParentProductId = coreApi.entities.getProductRef(hobConnector.host);
    const parentHeight =
      rootState.products.inMarket.find(p => p.coreProductId === hobParentProductId)?.dimensions
        .height ?? 1000;
    const parentPosition = hobConnector.getWorldPositionFromOwnerEntity(hobConnector.host);
    const yValue = parentPosition.Y + parentHeight / 2 + hoodOffset;
    targetPosition = new Vector(parentPosition.X, yValue, parentPosition.Z);
  }

  currentHood && coreApi.entities.delete(currentHood);

  if (targetPosition) {
    const entity = coreApi.entities.create(props.coreProductId);
    entity && coreApi.placementService.snapToPosition(entity, targetPosition, true);
  } else {
    coreApi.products.add(props.coreProductId);
  }
};

export default addHood;
